import {MedicationState} from "../../services/medicationmanagement/medications";
import Box from "@material-ui/core/Box";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles({
    strikeThrough:{
        textDecoration:"line-through"
    }
})

export const MedicationStateTextStyle=(props:{medicationState:MedicationState; stateConfirmed: boolean; children:any})=>{
    const classes = useStyles();
    
    if(props.medicationState === MedicationState.Ceased && !props.stateConfirmed)
        return <Box className={classes.strikeThrough}>{props.children}</Box> 
    return  <>{props.children}</>
}
